import { ImportedRanking } from './ImportedRanking';

/**
 * Class representing a user imported ranking.
 * @extends ImportedRanking
 */
export class UserImportedRanking extends ImportedRanking {}
